const u_PromiseSequential = async (PromiseArr) => {
  let res = [];
  for (let i = 0; i < PromiseArr.length; i++) {
    res.push(await PromiseArr[i]);
  }
  return res;
}

document.addEventListener('alpine:init', () => {
  let DEBUG = false;
  let MARK_SUPPORTER_DRAFT_ORDERS_PAID = false;
  if (DEBUG) {
    MARK_SUPPORTER_DRAFT_ORDERS_PAID = false;
  }
  const API_URL = 'https://app-falavory-team-orders-83cd2ed098d8.herokuapp.com';
  
  Alpine.data('TeamOrders', (config) => ({
    flags: {
      appLoaded: false,
      isLoggedIn: config.isLoggedIn || false,
      showPreviousOrders: false,
      showTeamOrderForm: false,
      shippingType: '',
      toggleSupporterForm: false,
      editingSupporter: false,
      minOrderValueReached: false,
      freeGiftTier1Reached: false,
      freeGiftTier2Reached: false,
      processing: false
    },
    shippingTypes: [
      { value: 'ship_to_leader_address', text: 'Ship to Team Leader address', shipping: 'Free Shipping' },
      { value: 'ship_individual', text: 'Ship Individually to each supporter', shipping: '$10.00 flat rate shipping across Canada' }
    ],
    team_leader: {
      first_name: config.team_leader?.first_name || '',
      last_name: config.team_leader?.last_name || '',
      id: config.team_leader?.id || '',
      email: config.team_leader?.email || '',
      phone: config.team_leader?.phone || '',
      shipping_address: {
        address1: config.team_leader?.shipping_address?.address1 || '',
        address2: config.team_leader?.shipping_address?.address2 || '',
        city: config.team_leader?.shipping_address?.city || '',
        province: config.team_leader?.shipping_address?.province || '',
        country: config.team_leader?.shipping_address?.country || '',
        zip: config.team_leader?.shipping_address?.zip || ''
      }
    },
    current_order: {
      team_id: '',
      team: null,
      supporters: [],
      supporter: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        shipping_address: {
          address1: '',
          address2: '',
          city: '',
          province: '',
          country: 'Canada',
          zip: '',
        },
        items: [],
        free_gift_tier_1: null,
        free_gift_tier_2: null,
        supporting_team: null,
        supporting_team_name: '',
        supporting_player: '',
        invalid_fields: []
      },
      invalid_fields: []
    },
    orders: config.orders || [],
    collection: config.collection || null,
    supporting_teams: config.supporting_teams || [],
    free_gift_tier_1_products: [],
    free_gift_tier_2_products: [],
    created_supporter_orders: [],
    created_main_order: [],
    async init() {
      // call API to check if it's reachable
      try {
        await fetch(`${API_URL}/api-status`).then(res => res.json());
        this.flags.appLoaded = true;
        this.InitWatchers();
        this.InitSelf();
      }
      catch (e) {
        console.error("Error connecting to MTO API");
      }

      this.InitWatchers();
    },

    InitSelf() {
      this.collection.products.forEach(product => {
        product.quantity = 0;
        product.isFreeGift = false;
      });
      this.free_gift_tier_1_products = [...this.collection.products.filter(product => product.type == 'Soup')];
      this.free_gift_tier_2_products = [...this.collection.products.filter(product => product.type == 'Dip Mix')];

      // show team order form directly if logged in
      if (this.flags.isLoggedIn) {
        this.flags.showTeamOrderForm = true;
      }

      if (DEBUG) {
        this.team_leader.first_name = 'Satish';
        this.team_leader.last_name = 'Voddi';
        this.team_leader.email = 'sv.vsat2k1@gmail.com';
        this.team_leader.shipping_address.address1 = '123 Main St';
        this.team_leader.shipping_address.city = 'Vancouver';
        this.team_leader.shipping_address.province = 'British Columbia';
        this.team_leader.shipping_address.country = 'Canada';
        this.team_leader.shipping_address.zip = 'V5K 0A1';

        this.current_order.supporter.first_name = 'John';
        this.current_order.supporter.last_name = 'Doe';
        this.current_order.supporter.email = 'voddisatish514@gmail.com';
        this.current_order.supporter.phone = '123-456-7890';
        this.current_order.supporter.shipping_address.address1 = '123 Main St';
        this.current_order.supporter.shipping_address.city = 'Vancouver';
        this.current_order.supporter.shipping_address.province = 'British Columbia';
        this.current_order.supporter.shipping_address.country = 'Canada';
        this.current_order.supporter.shipping_address.zip = 'V5K 0A1';
        let supporting_team = this.supporting_teams[0];
        this.current_order.supporter.supporting_team = supporting_team;
        this.current_order.supporter.supporting_team_name = supporting_team.team_name;
        this.$nextTick(() => {
          this.current_order.supporter.supporting_player = supporting_team.players[0];
        });
      }
    },
    
    InitWatchers() {
      // update supporting_team object when supporting_team_name selected
      this.$watch('current_order.supporter.supporting_team_name', (value) => {
        const team = this.supporting_teams.find(item => item.team_name === value);
        if (team) {
          this.current_order.supporter.supporting_team = team;
        }
      });

      // update invalid_fields array when supporter fields change
      this.$watch('current_order.supporter', () => {
        if (this.current_order.supporter.invalid_fields.length > 0) {
          this.u_CheckValidSupporter();
        }
      });

      this.$watch('current_order', () => {
        if (this.current_order.invalid_fields.length > 0) {
          this.u_CheckValidOrder();
        }
      });

      // update team info when team_id changes (for team leaders)
      this.$watch('current_order.team_id', () => {
        const team = this.supporting_teams.find(item => item.team_name === this.current_order.team_id);
        if (team) {
          this.current_order.team = { ...team };
          this.team_leader.first_name = team.team_leader_name.split(' ')[0];
          this.team_leader.last_name = team.team_leader_name.split(' ')[1];
          this.team_leader.email = team.team_leader_email_address;
          this.team_leader.shipping_address = { ...team.shipping_address };
          this.current_order.supporter.supporting_team = { ...team };
          this.current_order.supporter.supporting_team_name = team.team_name;
        }
      });

      // reset player when supporting_team_name changes
      this.$watch('current_order.supporter.supporting_team_name', () => {
        this.current_order.supporter.supporting_player = '';
      });

      // toggle modal-inview class on body when supporter form is toggled
      this.$watch('flags.toggleSupporterForm', (value) => {
        document.body.classList.toggle('modal-inview', value);
      });

      // set team leader with suppporter info if shipping type is ship_individual
      this.$watch('current_order.supporters', () => {
        if (this.flags.shippingType == 'ship_individual') {
          if (this.current_order.supporters.length > 0) {
            let first_supporter = this.current_order.supporters[0];
            this.team_leader.first_name = first_supporter.first_name;
            this.team_leader.last_name = first_supporter.last_name;
            this.team_leader.email = first_supporter.email;
            this.team_leader.phone = first_supporter.phone;
            this.team_leader.shipping_address = { ...first_supporter.shipping_address };
          }
        }
      });

      // reset current supporter when supporter form is closed
      this.$watch('flags.toggleSupporterForm', () => {
        if (!this.flags.toggleSupporterForm) {
          this.ResetCurrentSupporter();
        }
      });

      this.$watch('current_order.supporter.items', () => {
        let items = [...this.current_order.supporter.items].filter(i => !i.isFreeGift);
        let total_amount = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

        this.flags.minOrderValueReached = total_amount >= 1500;

        // check free gift tier 1
        this.flags.freeGiftTier1Reached = this.free_gift_tier_1_products.length > 0 && total_amount >= 3000 && total_amount < 5000;
        if (!this.flags.freeGiftTier1Reached) {
          this.current_order.supporter.free_gift_tier_1 = null;
        }

        // check free gift tier 2
        this.flags.freeGiftTier2Reached = this.free_gift_tier_2_products.length > 0 && total_amount >= 5000;
        if (!this.flags.freeGiftTier2Reached) {
          this.current_order.supporter.free_gift_tier_2 = null;
        } 
      });

      // free gift tier 1 watcher
      this.$watch('current_order.supporter.free_gift_tier_1', Alpine.debounce(() => {
        // console.log(this.current_order.supporter.free_gift_tier_1);
        let free_gift_tier_1_id = this.current_order.supporter.free_gift_tier_1;
        let items = [...this.current_order.supporter.items];
        // remove existing free gift tier 1 items
        let existing_index = items.findIndex(p => p.isFreeGift && p.freeGiftTier == 'tier1');
        if (existing_index !== -1) {
          items.splice(existing_index, 1);
        }

        // add new free gift tier 1 item
        let product = this.free_gift_tier_1_products.find(p => p.id == free_gift_tier_1_id);
        if (product) {
          product.isFreeGift = true;
          product.freeGiftTier = 'tier1';
          items.push({ ...product });
        }
        this.current_order.supporter.items = [...items];
        // console.log(items)
      }), 300);

      // free gift tier 2 watcher
      this.$watch('current_order.supporter.free_gift_tier_2', Alpine.debounce(() => {
        // console.log(this.current_order.supporter.free_gift_tier_2);
        let free_gift_tier_2_id = this.current_order.supporter.free_gift_tier_2;
        let items = [...this.current_order.supporter.items];
        // remove existing free gift tier 2 items
        let existing_index = items.findIndex(p => p.isFreeGift && p.freeGiftTier == 'tier2');
        if (existing_index !== -1) {
          items.splice(existing_index, 1);
        }

        // add new free gift tier 2 item
        let product = this.free_gift_tier_2_products.find(p => p.id == free_gift_tier_2_id);
        if (product) {
          product.isFreeGift = true;
          product.freeGiftTier = 'tier2';
          items.push({ ...product });
        }
        this.current_order.supporter.items = [...items];
        // console.log(items)
      }), 300);
    },

    FormatMoney(value) {
      return window.currency.formatMoney(value);
    },

    ResetCurrentSupporter() {
      let supporting_team = this.supporting_teams.length > 0 ? this.supporting_teams[0] : null;
      if (this.flags.shippingType == 'ship_to_leader_address') {
        supporting_team = this.current_order.team;
      }
      let supporting_team_name = supporting_team ? supporting_team.team_name : '';

      this.current_order.supporter = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        shipping_address: {
          address1: '',
          address2: '',
          city: '',
          province: '',
          country: 'Canada',
          zip: ''
        },
        items: [],
        supporting_team: supporting_team,
        supporting_team_name: supporting_team_name,
        supporting_player: '',
        invalid_fields: []
      };

      if (!this.flags.editingSupporter) {
        this.collection.products.forEach(product => {
          product.quantity = 0;
          product.isFreeGift = false;
        });
      }
    },

    // event handlers
    e_UpdateSupporterLineItem(e, product) {
      let items = [...this.current_order.supporter.items];
      let line_item = {...product};
      line_item.quantity = parseInt(e.target.value, 10);
      const existing_line_item = items.find(i => i.id === product.id);
      if (!existing_line_item) {
        items = [...items, { ...line_item }];
      }
      else {
        existing_line_item.quantity = parseInt(e.target.value, 10);
      }
      // remove items with quantity 0
      items = [...items.filter(i => i.quantity > 0)];
      this.current_order.supporter.items = [...items];
    },

    e_AddSupporter(e) {
      let supporter = this.current_order.supporter;
      supporter.id = Date.now();

      // check if valid supporter
      this.u_CheckValidSupporter();

      if (supporter.invalid_fields.length > 0) {
        return;
      }
      supporter.invalid_fields = [];

      if (this.flags.editingSupporter) {
        const index = this.current_order.supporters.findIndex(s => s.id === supporter.id);
        if (index !== -1) {
          this.current_order.supporters.splice(index, 1, { ...supporter });
        }
        this.flags.editingSupporter = false;
      }
      else {
        this.current_order.supporters = [
          ...this.current_order.supporters,
          { ...supporter }
        ];
      }

      this.flags.toggleSupporterForm = false;
    },

    u_CheckValidOrder() {
      let team_leader = this.team_leader;
      let current_order = this.current_order;
      for(let field in team_leader) {
        switch(field) {
          case 'email':
            if (team_leader[field] === '') {
              if (!team_leader.invalid_fields.includes(field)) {
                current_order.invalid_fields.push(field);
              }
            }
            else {
              const index = current_order.invalid_fields.indexOf(field);
              if (index !== -1) {
                current_order.invalid_fields.splice(index, 1);
              }
            }
            break;
          case 'shipping_address':
            for(let subfield in team_leader.shipping_address) {
              if (subfield !== 'address2') {
                if (team_leader.shipping_address[subfield] === '') {
                  if (!current_order.invalid_fields.includes(subfield)) {
                    current_order.invalid_fields.push(subfield);
                  }
                }
                else {
                  const index = current_order.invalid_fields.indexOf(subfield);
                  if (index !== -1) {
                    current_order.invalid_fields.splice(index, 1);
                  }
                }
              }
            }
            break;
        }
      }
    },

    u_CheckValidSupporter() {
      let supporter = this.current_order.supporter;
      for(let field in supporter) {
        switch(field) {
          case 'first_name':
          case 'last_name':
          case 'email':
          case 'supporting_team_name':
          case 'supporting_player':
            if (supporter[field] === '') {
              if (!supporter.invalid_fields.includes(field)) {
                supporter.invalid_fields.push(field);
              }
            }
            else {
              const index = supporter.invalid_fields.indexOf(field);
              if (index !== -1) {
                supporter.invalid_fields.splice(index, 1);
              }
            }
            break;
          case 'shipping_address':
            // only validate shipping address if shippingType is ship_individual
            if (this.flags.shippingType == 'ship_individual') {
              for(let subfield in supporter.shipping_address) {
                if (subfield !== 'address2') {
                  if (supporter.shipping_address[subfield] === '') {
                    if (!supporter.invalid_fields.includes(subfield)) {
                      supporter.invalid_fields.push(subfield);
                    }
                  }
                  else {
                    const index = supporter.invalid_fields.indexOf(subfield);
                    if (index !== -1) {
                      supporter.invalid_fields.splice(index, 1);
                    }
                  }
                }
              }
            }
            break;
          case 'items':
            if (supporter.items.length === 0) {
              if (!supporter.invalid_fields.includes(field)) {
                supporter.invalid_fields.push(field);
              }
            }
            else {
              const index = supporter.invalid_fields.indexOf(field);
              if (index !== -1) {
                supporter.invalid_fields.splice(index, 1);
              }
            }
            break;
        }
      }
    },

    e_OpenSupporterForm() {
      if (this.flags.shippingType == 'ship_to_leader_address' && this.current_order.team == null) {
        alert('Please select a team first.');
        return;
      }
      this.flags.toggleSupporterForm = true;
    },

    e_EditSupporter(supporter) {
      this.collection.products.forEach(product => {
        const item = supporter.items.find(i => i.id === product.id);
        product.quantity = item ? item.quantity : 0;
      });
      this.current_order.supporter = { ...supporter };
      this.flags.toggleSupporterForm = true;
      this.flags.editingSupporter = true;
    },

    e_RemoveSupporter(supporter) {
      const index = this.current_order.supporters.indexOf(supporter);
      if (index !== -1) {
        this.current_order.supporters.splice(index, 1);
      }
    },

    async e_SubmitOrder() {
      this.u_CheckValidOrder();
      if (this.current_order.invalid_fields.length > 0) {
        return;
      }

      if (this.current_order.supporters.length === 0) {
        alert('Please add at least one supporter to the order.');
        return;
      }

      this.current_order.invalid_fields = [];
      this.flags.processing = true;

      // create individual orders for supporters if shipping to leader address
      if (this.flags.shippingType == 'ship_to_leader_address') {
        await this.CreateOrdersForSupporters();
      }
      // Add a time out to ensure all supporter orders are created before creating team leader order
      let timeout = this.current_order.supporters.length * 1000 + 500;
      setTimeout(() => {
        this.CreateDraftOrderForPayment();
      }, timeout);
    },

    async CreateOrdersForSupporters() {
      let am = this;
      // create orders for each supporter
      let orderPromises = this.current_order.supporters.map(async (supporter, index) => {
        let line_items = supporter.items.map(item => {
          let quantity = item.isFreeGift ? 1 : item.quantity;
          return {
            variant_id: item.variants[0].id,
            quantity: quantity,
            properties: [
              { name: 'Team', value: supporter.supporting_team_name },
              { name: 'Player', value: supporter.supporting_player },
            ]
          }
        });
        
        let order_tags = ['team-order', 'supporter-order'];
        order_tags.push(supporter.supporting_team_name);
        order_tags.push(supporter.supporting_player);

        let note_attributes = [];
        note_attributes.push({ name: 'Team Name', value: supporter.supporting_team_name });
        note_attributes.push({ name: 'Player', value: supporter.supporting_player });

        let supporter_order_payload = {
          shop_name: Shopify.shop,
          draft_order: {
            email: supporter.email,
            line_items: line_items,
            tags: order_tags.join(','),
            note_attributes: note_attributes,
            shipping_address: {
              first_name: supporter.first_name,
              last_name: supporter.last_name,
              address1: supporter.shipping_address.address1,
              address2: supporter.shipping_address.address2,
              city: supporter.shipping_address.city,
              province: supporter.shipping_address.province,
              country: supporter.shipping_address.country,
              zip: supporter.shipping_address.zip,
              phone: supporter.phone
            }
          }
        };

        // Apply 100% discount to supporter orders, so they don't have to pay
        supporter_order_payload.draft_order.applied_discount = {
          description: 'SUPPORTER-ORDER',
          value_type: 'percentage',
          value: 100,
          amount: 0,
          title: 'SUPPORTER-ORDER'
        };

        setTimeout(async() => {
          let res = await fetch(`${API_URL}/api/create-draft-order`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(supporter_order_payload),
          });

          if (res.ok) {
            let draft_order_supporter = await res.json();
            console.log('Draft Order created:', draft_order_supporter);
            am.created_supporter_orders.push(draft_order_supporter);

            // complete draft order
            if (MARK_SUPPORTER_DRAFT_ORDERS_PAID) {
              await fetch(`${API_URL}/api/complete-draft-order`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  shop_name: Shopify.shop,
                  draft_order_id: draft_order_supporter.id
                }),
              });
            }
          }
        }, index * 1000); // to avoid hitting rate limits
      });

      return await u_PromiseSequential(orderPromises);
    },

    async AddCustomerTagsToTeamLeader() {
      // add 'team-leader' tag to team leader customer
      let payload = {
        shop_name: Shopify.shop,
        customer_id: this.team_leader.id,
        tag: 'team-leader'
      };
      return await fetch(`${API_URL}/api/add-customer-tag`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    },
    
    async CreateDraftOrderForPayment() {
      // create draft order for team leader
      let line_items = this.current_order.supporters.flatMap(supporter => {
        return supporter.items.map(item => {
          let quantity = item.isFreeGift ? 1 : item.quantity;
          let line_item = {
            variant_id: item.variants[0].id,
            quantity: quantity,
            properties: [
              { name: 'Team', value: supporter.supporting_team_name },
              { name: 'Player', value: supporter.supporting_player },
              { name: 'Supporter Name', value: `${supporter.first_name} ${supporter.last_name}` }
            ]
          };
          if (item.isFreeGift) {
            line_item.properties.push({ name: '_FreeGift', value: true });
            line_item.applied_discount = {
              "description": "FREE GIFT",
              "value_type": "percentage",
              "value": 100,
              "amount": 0,
              "title": "FREE GIFT"
            };
          }
          return line_item;
        });
      });

      let order_tags = ['team-order'];
      if (this.flags.shippingType == 'ship_to_leader_address') {
        order_tags.push('ship-teamleader');
      }
      else if (this.flags.shippingType == 'ship_individual') {
        order_tags.push('ship-individual-supporter');
      }
      order_tags.push(this.current_order.team.team_name);

      let note_attributes = [];

      if (this.flags.shippingType == 'ship_to_leader_address') { 
        note_attributes.push({ name: 'Team Name', value: this.current_order.team ? this.current_order.team.team_name : '' });
        note_attributes.push({ name: 'Players', value: this.current_order.supporters.map(s => s.supporting_player).join(', ') });
        note_attributes.push({ name: 'Number of Supporters', value: this.current_order.supporters.length });
        note_attributes.push({ name: 'Supporter Orders', value: this.created_supporter_orders.map(so => so.id).join(',') });

        this.created_supporter_orders.forEach((supporter_order, index) => {
          note_attributes.push({ name: `Supporter Order ${index + 1} ID`, value: `https://admin.shopify.com/store/falavory/draft_orders/${supporter_order.id}` });
        });
      }
      else {
        note_attributes.push({ name: 'Team Name', value: this.current_order.supporters[0].supporting_team_name });
        note_attributes.push({ name: 'Players', value: this.current_order.supporters.map(s => s.supporting_player).join(', ') });
      }

      let teamleader_order_payload = {
        shop_name: Shopify.shop,
        draft_order: {
          customer_id: this.team_leader.id || null,
          email: this.team_leader.email,
          line_items: line_items,
          tags: order_tags.join(','),
          note_attributes: note_attributes,
          shipping_address: {
            first_name: this.team_leader.first_name,
            last_name: this.team_leader.last_name,
            address1: this.team_leader.shipping_address.address1,
            address2: this.team_leader.shipping_address.address2,
            city: this.team_leader.shipping_address.city,
            province: this.team_leader.shipping_address.province,
            country: this.team_leader.shipping_address.country,
            zip: this.team_leader.shipping_address.zip,
            phone: this.team_leader.phone
          }
        },
      };

      if (DEBUG) {
        teamleader_order_payload.draft_order.applied_discount = {
          description: 'Test Discount',
          value_type: 'percentage',
          value: 100,
          amount: 0,
          title: 'Test Discount'
        };
      }

      if (this.flags.shippingType == 'ship_to_leader_address') {
        teamleader_order_payload.draft_order.applied_discount = {
          description: 'FREE Shipping',
          value_type: 'fixed_amount',
          value: 10,
          amount: 10,
          title: 'FREE Shipping'
        };
      }

      let res = await fetch(`${API_URL}/api/create-draft-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(teamleader_order_payload),
      });

      if (res.ok) {
        let order_team_leader = await res.json();
        this.created_main_order = order_team_leader;
        console.log('Draft Order created:', order_team_leader);
        debugger;
        if (order_team_leader.invoice_url) {
          window.location.href = order_team_leader.invoice_url;
        }
        else {
          console.error('Error creating order. Please try again later.');
        }
      }
    }
  }));
});